import styles from './TableComponent.module.scss';

export const TableComponent = () => {
	return (
		<table className={styles.table}>
			<thead>
			<tr>
				<th style={{ width: "10%" }}>Класс</th>
				<th style={{ width: "15%" }}>Подкласс</th>
				<th style={{ width: "30%" }}>RUB (Россия)</th>
				<th style={{ width: "25%" }}>USD+RUB (США + Европа)</th>
				<th style={{ width: "20%" }}>CNY (Китай) </th>
			</tr>
			</thead>
			<tbody>
			<tr className="Equity">
				<td className="s0" rowSpan={6}>Акции</td>
				<td className="s01">Основной индекс</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A101EJ5" className="vtb under">EQMX</a>
					<a href="https://rusetfs.com/etf/RU000A0ZZH92" className="sber under">SBMX</a>
					<a href="https://rusetfs.com/etf/RU000A101X76" className="tinkoff under">TMOS</a>
					<a href="https://rusetfs.com/etf/BCSR/overview" className="etc under">BCSR</a>
					<a href="https://rusetfs.com/etf/IE00BQ1Y6480" className="finex under">FXRL</a>
					<a href="https://rusetfs.com/etf/LU1483649312" className="etc under zpifa">RUSE</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/RU000A103VE6" className="tinkoff under zpifa">TEUS</a>
					<a href="https://rusetfs.com/etf/IE00BMDKNM37" className="finex under">FXDM</a>
					<a href="https://rusetfs.com/etf/IE00BD3QJN10" className="finex under">FXDE</a>
					<a href="https://rusetfs.com/etf/RU000A100Q43" className="alpha under zpifa">AKEU</a>
					<a href="https://rusetfs.com/etf/RU000A103H82" className="open under zpifa">OPNE</a>
					<a href="https://rusetfs.com/etf/RU000A103WS4" className="rshb under zpifa">RSHL</a>
					<a href="https://rusetfs.com/etf/RU000A102EQ8" className="tinkoff under zpifa">TSPX</a>
					<a href="https://rusetfs.com/etf/RU000A100E21" className="rshb under zpifa">RSHA</a>
					<a href="https://rusetfs.com/etf/RU000A1006W1" className="sber under zpifa">SBSP</a>
					<a href="https://rusetfs.com/etf/IE00BD3QHZ91" className="finex under">FXUS</a>
					<a href="https://rusetfs.com/etf/RU000A1006V3" className="alpha under zpifa">AKSP</a>
					<a href="https://rusetfs.com/etf/RU000A103VK3" className="tinkoff under zpifa">TPAS</a>
					<a href="https://rusetfs.com/etf/IE00BK224M36" className="finex under">FXRW</a>
					<a href="https://rusetfs.com/etf/IE00BK224L29" className="finex under">FXWO</a>
					<a href="https://rusetfs.com/etf/RU000A104DF9" className="etc under zpifa">GPBW</a>
				</td>
				<td className="s4">
					<a href="https://rusetfs.com/etf/RU000A103VJ5" className="tinkoff under zpifa">TEMS</a>
					<a href="https://rusetfs.com/etf/RU000A103H74" className="open under zpifa">OPNA</a>
					<a href="https://rusetfs.com/etf/RU000A104D51" className="etc under zpifa">GPBC</a>
					<a href="https://rusetfs.com/etf/RU000A102FK8" className="alpha under zpifa">AKCH</a>
					<a href="https://rusetfs.com/etf/RU000A100HQ5" className="rshb under zpifa">RSHE</a>
					<a href="https://rusetfs.com/etf/IE0003KBK0Z6" className="finex under">FXEM</a>
					<a href="https://rusetfs.com/etf/IE00BG0C3K84" className="finex under">FXKZ</a>
					<a href="https://rusetfs.com/etf/IE00BD3QFB18" className="finex under">FXCN</a>
				</td>
			</tr>
			<tr className="Equity">
				<td className="s01">Tech компании</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/TITR/overview" className="tinkoff under">TITR</a>
					<a href="https://rusetfs.com/etf/AKHT/overview" className="alpha under">AKHT</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/RU000A100VK9" className="etc under">MTEK</a>
					<a href="https://rusetfs.com/etf/RU000A101X68" className="tinkoff under zpifa">TECH</a>
					<a href="https://rusetfs.com/etf/RU000A103VF3" className="tinkoff under zpifa">TSOX</a>
					<a href="https://rusetfs.com/etf/RU000A103VN7" className="tinkoff under zpifa">TCBR</a>
					<a href="https://rusetfs.com/etf/RU000A103VG1" className="tinkoff under zpifa">TRAI</a>
					<a href="https://rusetfs.com/etf/RU000A103VH9" className="tinkoff under zpifa">TFNX</a>
					<a href="https://rusetfs.com/etf/RU000A101LA9" className="etc under zpifa">SCIP</a>
					<a href="https://rusetfs.com/etf/RU000A0ZZTQ4" className="alpha under zpifa">AKNX</a>
					<a href="https://rusetfs.com/etf/IE00BD3QJ757" className="finex under">FXIT</a>
					<a href="https://rusetfs.com/etf/IE00BNC2D728" className="finex under">FXIM</a>
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Дивидендный фактор</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A102N02" className="etc under">DIVD</a>
					<a href="https://rusetfs.com/etf/RU000A103BX8" className="etc under">MKBD</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Прочие факторы</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/SBSC/overview" className="sber under">SBSC</a>
					<a href="https://rusetfs.com/etf/RU000A1024P8" className="sber under">SBRI</a>
					<a href="https://rusetfs.com/etf/RU000A103ZQ1" className="sber under">SBHI</a>
					<a href="https://rusetfs.com/etf/SBBC/overview" className="sber under">SBBC</a>
					<a href="https://rusetfs.com/etf/RU000A103H90" className="open under">OPNR</a>
					<a href="https://rusetfs.com/etf/AKBC/overview" className="alpha under">AKBC</a>
					<a href="https://rusetfs.com/etf/TRND/overview" className="tinkoff under">TRND</a>
					<a href="https://rusetfs.com/etf/RU000A103LL2" className="vtb under">ESGE</a>
					<a href="https://rusetfs.com/etf/SIPO/overview" className="sber under">SIPO</a>
					<a href="https://rusetfs.com/etf/RU000A101R66" className="rshb under">ESGR</a>
					<a href="https://rusetfs.com/etf/RU000A1037V8" className="etc under">GROD</a>
					<a href="https://rusetfs.com/etf/RU000A104FE7" className="etc under">SCFT</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/RU000A103D52" className="open under zpifa">OPNS</a>
					<a href="https://rusetfs.com/etf/RU000A102EK1" className="tinkoff under zpifa">TBIO</a>
					<a href="https://rusetfs.com/etf/RU000A1036A4" className="alpha under zpifa">AKMD</a>	
					<a href="https://rusetfs.com/etf/RU000A102EM7" className="tinkoff under zpifa">TIPO</a>
					<a href="https://rusetfs.com/etf/RU000A103VL1" className="tinkoff under zpifa">TBUY</a>
					<a href="https://rusetfs.com/etf/RU000A104B87" className="sber under zpifa">SBBE</a>
					<a href="https://rusetfs.com/etf/IE000GBF7ZU3" className="finex under">FXBC</a>
					<a href="https://rusetfs.com/etf/IE00BNYK7W79" className="finex under">FXES</a>
					<a href="https://rusetfs.com/etf/RU000A103L86" className="alpha under zpifa">AKSC</a>
					<a href="https://rusetfs.com/etf/RU000A103ZD9" className="alpha under zpifa">AKVG</a>
					<a href="https://rusetfs.com/etf/RU000A1039P6" className="tinkoff under zpifa">TGRN</a>
					<a href="https://rusetfs.com/etf/RU000A103VM9" className="tinkoff under zpifa">TSST</a>
					<a href="https://rusetfs.com/etf/RU000A1046S5" className="etc under zpifa">GQGD</a>
					<a href="https://rusetfs.com/etf/RU000A1046U1" className="etc under zpifa">GLVD</a>
					<a href="https://rusetfs.com/etf/RU000A1046T3" className="etc under zpifa">GSCD</a>
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Equity">
				<td className="s01">Активное управление</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A103NR5" className="alpha under">AKQU</a>
					<a href="https://rusetfs.com/etf/AKIE/overview" className="alpha under">AKIE</a>
					<a href="https://rusetfs.com/etf/RU000A102E78" className="alpha under">AKME</a>
					<a href="https://rusetfs.com/etf/RU000A102XX4" className="etc under">AMRE</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>

			<tr className="BlankRaw">
			</tr>
			<tr className="Debt">
				<td className="s0" rowSpan={5}>Облигации</td>
				<td className="s01">Денежный рынок</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1014L8" className="vtb under">LQDT</a>
					<a href="https://rusetfs.com/etf/RU000A103RF1" className="sber under">SBMM</a>
					<a href="https://rusetfs.com/etf/AKMM/overview" className="alpha under">AKMM</a>
					<a href="https://rusetfs.com/etf/AKMP/overview" className="alpha under">AKMP</a>
					<a href="https://rusetfs.com/etf/TMON/overview" className="tinkoff under">TMON</a>
					<a href="https://rusetfs.com/etf/AMNR/overview" className="etc under">AMNR</a>
					<a href="https://rusetfs.com/etf/PSMM/overview" className="etc under">PSMM</a>
					<a href="https://rusetfs.com/etf/SCLI/overview" className="etc under">SCLI</a>
					<a href="https://rusetfs.com/etf/BCSD/overview" className="etc under">BCSD</a>
					<a href="https://rusetfs.com/etf/FINC/overview" className="etc under">FINC</a>
					<a href="https://rusetfs.com/etf/FMMM/overview" className="etc under">FMMM</a>
					<a href="https://rusetfs.com/etf/GOOD/overview" className="etc under">GOOD</a>
					<a href="https://rusetfs.com/etf/CASH/overview" className="etc under">CASH</a>
					<a href="https://rusetfs.com/etf/MONY/overview" className="etc under">MONY</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/IE00BL3DYX33" className="finex under">FXMM</a>
					<a href="https://rusetfs.com/etf/IE00BL3DYW26" className="finex under">FXTB</a>

				</td>
				<td className="s4">
					<a href="https://rusetfs.com/etf/AMNY/overview" className="etc under">AMNY</a>
					<a href="https://rusetfs.com/etf/CNYM/overview" className="vtb under" >CNYM</a>
					<a href="https://rusetfs.com/etf/SBCN/overview" className="sber under">SBCN</a>
				</td>
			</tr>
			<tr className="Debt">
				<td className="s01">Госдолг</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1000F9" className="sber under">SBGB</a>
					<a href="https://rusetfs.com/etf/SBLB/overview" className="sber under">SBLB</a>
					<a href="https://rusetfs.com/etf/TOFZ/overview" className="tinkoff under">TOFZ</a>
					<a href="https://rusetfs.com/etf/RU000A103HB1" className="open under">OPNB</a>
					<a href="https://rusetfs.com/etf/AMGB/overview" className="etc under">AMGB</a>
				</td>
				<td className="s2">
					<a href="https://rusetfs.com/etf/IE00BNYK7X86" className="finex under">FXTP</a>
					<a href="https://rusetfs.com/etf/IE00096YBNR3" className="finex under">FXIP</a>

				</td>
				<td className="s4"></td>
			</tr>
			<tr className="Debt">
				<td className="s01">Переменные купоны и индексация </td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/SBFR/overview" className="sber under">SBFR</a>
					<a href="https://rusetfs.com/etf/AKFB/overview" className="alpha under">AKFB</a>
					<a href="https://rusetfs.com/etf/TPAY/overview" className="tinkoff under">TPAY</a>
					<a href="https://rusetfs.com/etf/RU000A1047H6" className="etc under">INFL</a>
					<a href="https://rusetfs.com/etf/SMCF/overview" className="etc under">SMCF</a>
				</td>
				<td className="s2"></td>
				<td className="s4"></td>
			</tr>
			<tr className="Debt">
				<td className="s01">Корпоративные облигации</td>
				<td className="s1">
					<a href="https://rusetfs.com/etf/RU000A1002S8" className="vtb under">OBLG</a>
					<a href="https://rusetfs.com/etf/RU000A100P44" className="sber under">SBRB</a>
					<a href="https://rusetfs.com/etf/RU000A101PN3" className="alpha under">AKMB</a>
					<a href="https://rusetfs.com/etf/RU000A1039N1" className="tinkoff under">TBRU</a>
					<a href="https://rusetfs.com/etf/RU000A102XY2" className="etc under">AMRB</a>
					<a href="https://rusetfs.com/etf/RU000A1009F0" className="etc under">GPBM</a>
					<a href="https://rusetfs.com/etf/RU000A1009E3" className="etc under">GPBS</a>
					<a href="https://rusetfs.com/etf/RU000A1038R4" className="etc under">SPBC</a>
					<a href="https://rusetfs.com/etf/RU000A103CA4" className="etc under">INGO</a>
					<a href="https://rusetfs.com/etf/RU000A104Z22" className="etc under">BOND</a>
					<a href="https://rusetfs.com/etf/BNDA/overview" className="etc under">BNDA</a>
					<a href="https://rusetfs.com/etf/BNDB/overview" className="etc under">BNDB</a>
					<a href="https://rusetfs.com/etf/BNDC/overview" className="etc under">BNDC</a>
					<a href="https://rusetfs.com/etf/PSRB/overview" className="etc under">PSRB</a>
					<a href="https://rusetfs.com/etf/AMFL/overview" className="etc under">AMFL</a>
				</td>
				<td className="s2" dir="ltr">
					<a href="https://rusetfs.com/etf/RU000A103TD2" className="tinkoff under">TBEU</a>
					<a href="https://rusetfs.com/etf/RU000A107597" className="tinkoff under">TLCB</a>
					<a href="https://rusetfs.com/etf/RU000A101368" className="rshb under">RSHU</a>
					<a href="https://rusetfs.com/etf/RU000A1000Q6" className="sber under">SBCB</a>
					<a href="https://rusetfs.com/etf/RU000A1030R1" className="rshb under">PRIE</a>
					<a href="https://rusetfs.com/etf/IE00BD5FH213" className="finex under">FXRU</a>
					<a href="https://rusetfs.com/etf/LU1483649825" className="etc under zpifa">RUSB</a>
					<a href="https://rusetfs.com/etf/RU000A103BH1" className="rshb under zpifa">RSHI</a>
				</td>
				<td className="s4">
					<a href="https://rusetfs.com/etf/SBBY/overview" className="sber under">SBBY</a>
					<a href="https://rusetfs.com/etf/YUAN/overview" className="etc under">YUAN</a>
					<a href="https://rusetfs.com/etf/RU000A1024J1" className="rshb under zpifa">RSHY</a>
					<a href="https://rusetfs.com/etf/RU000A103ZC1" className="alpha under zpifa">AKEB</a>
					<a href="https://rusetfs.com/etf/RU000A103CZ1" className="etc under zpifa">INEM</a>
				</td>
			</tr>
			<tr className="Debt">
				<td className="s01">Высокодоходные облигации</td>
				<td className="s1">

					<a href="https://rusetfs.com/etf/RU000A103FW1" className="etc under">AMRH</a>
					<a href="https://rusetfs.com/etf/RU000A102ST2" className="etc under">BCSB</a>
				</td>
				<td className="s2" dir="ltr">
					<a href="https://rusetfs.com/etf/IE00BMDKNN44" className="finex under">FXFA</a>
					<a href="https://rusetfs.com/etf/IE000CK9ZWC0" className="finex under">FXRD</a>
					<a href="https://rusetfs.com/etf/RU000A103HA3" className="open under zpifa">OPNU</a>
					<a href="https://rusetfs.com/etf/RU000A100HP7" className="rshb under zpifa">RSHH</a>
				</td>
				<td className="s4"></td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Commodity">
				<td className="s0" dir="ltr" rowSpan={1}>Товары</td>
				<td className="s01">Золото и серебро</td>
				<td className="s4 align-middle" colSpan={5}>
					<a href="https://rusetfs.com/etf/RU000A105385" className="sber under" >SBGD</a>
					<a href="https://rusetfs.com/etf/RU000A101NZ2" className="vtb under" >GOLD</a>
					<a href="https://rusetfs.com/etf/RU000A1045N8" className="alpha under" >AKGD</a>
					<a href="https://rusetfs.com/etf/AKPP/overview" className="alpha under" >AKPP</a>
					<a href="https://rusetfs.com/etf/RU000A101X50" className="tinkoff under">TGLD</a>
					<a href="https://rusetfs.com/etf/IE00B8XB7377" className="finex under" >FXGD</a>
					<a href="https://rusetfs.com/etf/PSGM/overview" className="etc under">PSGM</a>
				</td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Hybrid">
				<td className="s0" colSpan={2}>Недвижимость</td>
				<td className="s1 align-middle"></td>
				<td className="s2 align-middle"><a href="https://rusetfs.com/etf/IE0000CHPRB9" className="finex under">FXRE</a></td>
				<td className="s4 align-middle"></td>
			</tr>
			<tr className="BlankRaw">
			</tr>
			<tr className="Hybrid">
				<td className="s0" colSpan={2}>Смешанные</td>
				<td className="s1 align-middle">
					<a href="https://rusetfs.com/etf/RU000A1011U5" className="tinkoff under">TRUR</a>
					<a href="https://rusetfs.com/etf/AKUP/overview" className="alpha under">AKUP</a>
					<a href="https://rusetfs.com/etf/AKAI/overview" className="alpha under">AKAI</a>
					<a href="https://rusetfs.com/etf/RU000A1035N9" className="sber under">SBCS</a>
					<a href="https://rusetfs.com/etf/RU000A1035R0" className="sber under">SBPS</a>
					<a href="https://rusetfs.com/etf/BCSW/overview" className="etc under">BCSW</a>
				</td>
				<td className="s2 align-middle">
					<a href="https://rusetfs.com/etf/RU000A1011S9" className="tinkoff under">TUSD</a>
					<a href="https://rusetfs.com/etf/RU000A1011T7" className="tinkoff under">TEUR</a>
					<a href="https://rusetfs.com/etf/RU000A1035Q2" className="sber under">SBRS</a>
					<a href="https://rusetfs.com/etf/RU000A1035S8" className="sber under">SBWS</a>
					<a href="https://rusetfs.com/etf/RU000A1035L3" className="sber under">SBDS</a>
					<a href="https://rusetfs.com/etf/RU000A104B95" className="sber under zpifa">SBOG</a>
					<a href="https://rusetfs.com/etf/RU000A104CU0" className="alpha under zpifa">AKSF</a>
					<a href="https://rusetfs.com/etf/RU000A1024K9" className="open under zpifa">OPNW</a>
				</td>
				<td className="s4 align-middle"></td>
			</tr>
			</tbody>
		</table>
	);
}